import React from "react";

import PageBanner from "../components/common/PageBanner";
import AboutIntro from "../components/AboutPageComponents/AboutIntro";
import WhoWeAre from "../components/AboutPageComponents/WhoWeAre";
import GoalMission from "../components/AboutPageComponents/GoalMission";
import Vision from "../components/AboutPageComponents/Vision";
import WhyChooseUs from "../components/HomePageComponents/WhyChooseUs";

const About = () => {
  return (
    <>
      <PageBanner title="About us" />
      <AboutIntro />
      <WhoWeAre />
      <WhyChooseUs />
      <Vision />
      <GoalMission />
    </>
  );
};

export default About;
